import http from "../../http-common";
/* eslint-disable */
class RumahSakitService {
  rumahSakitList(page, itemPerPage, keyword) {
    return http.get(
      "/rumah-sakit/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("alamat", data.alamat);
    bodyFormData.append("phone", data.phone);
    bodyFormData.append("google_map_location", data.google_map_location);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.post("/rumah-sakit", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("alamat", data.alamat);
    bodyFormData.append("phone", data.phone);
    bodyFormData.append("google_map_location", data.google_map_location);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.put(`/rumah-sakit/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  delete(id) {
    return http.delete(`/rumah-sakit/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new RumahSakitService();
